'use strict';

require('./chunk-d7703e54.js');
var variadic = require('./variadic.js');

/**
 * Composes the given functions from right-to-left.
 *
 * @function
 * @param {Array} fs The functions to compose.
 * @returns {Function} A function that is the composition of the list of
 * functions `fs`.
 * @example
 *
 * import { compose } from 'fkit'
 * compose(f, g, h)(a) // f(g(h(a)))
 */

var compose = variadic(function (fs) {
  return function (a) {
    return fs.reduceRight(function (a, f) {
      return f(a);
    }, a);
  };
});

module.exports = compose;
